import {Component, OnInit} from '@angular/core';
import {Prediction} from '../../../../models/Prediction';
import {SpeechService} from '../../../../services/speech/speech.service';

@Component({
  selector: 'app-radar-chart',
  templateUrl: './radar-chart.component.html',
  styleUrls: ['./radar-chart.component.scss']
})
export class RadarChartComponent implements OnInit {
  public chartType = 'radar';
  public chartDatasets: Array<any> = [
    {data: [0, 0, 0, 0, 0, 0, 0, 0], label: 'Emotion Analysis'}
  ];
  public chartLabels: Array<any> = [Prediction.getAngryDefaultDescription(),
    Prediction.getDisgustDefaultDescription(),
    Prediction.getFearDefaultDescription(),
    Prediction.getHappyDefaultDescription(),
    Prediction.getNeutralDefaultDescription(),
    Prediction.getSadDefaultDescription(),
    Prediction.getSurpriseDefaultDescription(),
    Prediction.getContemptuousDefaultDescription()];
  public chartColors: Array<any> = [
    {
      borderColor: '#00FF00',
      borderWidth: 3,
    }
  ];

  public currentPrediction: any;

  public chartOptions: any = {
    responsive: true,

    scales: {
      scale: {
        ticks: {
          beginAtZero: true,
          min: 0,
          max: 100
        }
      }
    }
  };

  constructor(public speechService: SpeechService) {
    this.speechService.onPredictionRadarChart = (prediction: Prediction) => {
      this.addData(prediction);
    };
  }

  ngOnInit() {
    this.clear();
  }

  addData(prediction: Prediction) {
    this.currentPrediction = prediction;
    if (prediction != null) {
      this.chartLabels = [prediction.getAngryWithIcon(),
        prediction.getDisgustWithIcon(),
        prediction.getFearWithIcon(),
        prediction.getHappyWithIcon(),
        prediction.getNeutralWithIcon(),
        prediction.getSadWithIcon(),
        prediction.getSurpriseWithIcon(),
        prediction.getContemptuousWithIcon()];

      this.chartDatasets[0].data[0] = prediction.getRoundAngry();
      this.chartDatasets[0].data[1] = prediction.getRoundDisgust();
      this.chartDatasets[0].data[2] = prediction.getRoundFear();
      this.chartDatasets[0].data[3] = prediction.getRoundHappy();
      this.chartDatasets[0].data[4] = prediction.getRoundNeutral();
      this.chartDatasets[0].data[5] = prediction.getRoundSad();
      this.chartDatasets[0].data[6] = prediction.getRoundSurprise();
      this.chartDatasets[0].data[7] = prediction.getRoundContemptuous();
    } else {
      this.chartLabels = [Prediction.getAngryDefaultDescription(),
        Prediction.getDisgustDefaultDescription(),
        Prediction.getFearDefaultDescription(),
        Prediction.getHappyDefaultDescription(),
        Prediction.getNeutralDefaultDescription(),
        Prediction.getSadDefaultDescription(),
        Prediction.getSurpriseDefaultDescription(),
        Prediction.getContemptuousDefaultDescription()];
      this.chartDatasets[0].data[0] = 0;
      this.chartDatasets[0].data[1] = 0;
      this.chartDatasets[0].data[2] = 0;
      this.chartDatasets[0].data[3] = 0;
      this.chartDatasets[0].data[4] = 0;
      this.chartDatasets[0].data[5] = 0;
      this.chartDatasets[0].data[6] = 0;
      this.chartDatasets[0].data[7] = 0;
    }
  }

  clear() {
    this.chartDatasets[0].data = [];
    this.chartLabels = [];
  }

}
